/**
 * Los avisos que esperan una acción de quien los recibe, y no solo informan: van
 * primero en la campanita, en «Para revisar». Hoy, un pago que el cliente informó
 * y alguien tiene que verificar (trabajo autorizado o cobranza).
 */
const PARA_REVISAR: ReadonlySet<string> = new Set(['work_payment_informed', 'collections_payment_reported']);

export function esParaRevisar(kind: string): boolean {
  return PARA_REVISAR.has(kind);
}
